export const EXTERNAL_HOME = 'https://joor.com'
export const EXTERNAL_BRANDS = 'https://joor.com/brands'
export const EXTERNAL_RETAILERS = 'https://joor.com/retailers'
export const EXTERNAL_ABOUT = 'https://joor.com/company'
export const EXTERNAL_BLOG = 'https://blog.joor.com/'
export const HELP = 'https://help.jooraccess.com/hc/en-us'
export const EXTERNAL_DEMO_REQUEST = 'https://www.joor.com/demo-request'
export const EXTERNAL_CAREERS = 'https://joor.com/careers-at-joor'
export const EXTERNAL_CASE_STUDIES = 'https://joor.com/case-studies'
